// extracted by mini-css-extract-plugin
export default {"login":"login_login__QRLLA","loginHolder":"login_loginHolder__hFt35","inputHolder":"login_inputHolder__HwAmL"};